<template>
  <v-text-field
    :type="type"
    @keyup="userInput"
    :value="textValue"
    :readonly="readonly"
  >
  </v-text-field>
</template>

<script>
export default {
  name: 'PlainTextField',
  data: () => ({
    textValue: ''
  }),
  props: {
    type: String,
    value: String,
    readonly: {
      type: Boolean,
      default: false
    },
    onChangeValidation: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    // userInput(data) {
    //   if (!this.readonly && data) {
    //     const eventKeyCode = data.charCodeAt(data.length - 1)
    //     if (eventKeyCode >= 48 && eventKeyCode <= 57) {
    //       data.slice(-1)
    //       this.$emit('predict', data.slice(-1))
    //     }
    //   }
    // },
    userInput(event) {
      if (event.keyCode === 8) {
        this.textValue = 'null'
        this.$emit('predict', this.textValue)
      }

      if (event.keyCode >= 48 && event.keyCode <= 57) {
        const value = event.key.slice(-1)
        this.textValue = value
        this.$emit('predict', value)

        setTimeout(() => this.onChangeValidation(event.target.value), 500)
      }
    }
  },
  watch: {
    value: {
      handler(data) {
        this.textValue = data
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
.v-input__slot::before {
  display: none;
}
</style>
